import { render, staticRenderFns } from "./addPortWarehouse.vue?vue&type=template&id=cf57fa98&scoped=true&"
import script from "./addPortWarehouse.vue?vue&type=script&lang=js&"
export * from "./addPortWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./addPortWarehouse.vue?vue&type=style&index=0&id=cf57fa98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf57fa98",
  null
  
)

export default component.exports